/**
 * @flow
 * @relayHash fadb0da008a77c43009186ad6f624dec
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type EventDualSearchPage_viewer$ref = any;
export type EventDualSearchPageRefetchQueryVariables = {|
  eventId: string,
  language?: ?string,
  startnumber: string,
  searchStartnumber: string,
  count: number,
  cursor?: ?string,
  secondFactor?: ?string,
  individualPart?: ?string,
  isRecheckPage: boolean,
|};
export type EventDualSearchPageRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: EventDualSearchPage_viewer$ref
  |}
|};
export type EventDualSearchPageRefetchQuery = {|
  variables: EventDualSearchPageRefetchQueryVariables,
  response: EventDualSearchPageRefetchQueryResponse,
|};
*/


/*
query EventDualSearchPageRefetchQuery(
  $eventId: ID!
  $language: String
  $startnumber: ID!
  $searchStartnumber: ID!
  $count: Int!
  $cursor: String
  $secondFactor: String
  $individualPart: String
  $isRecheckPage: Boolean!
) {
  viewer {
    ...EventDualSearchPage_viewer
    id
  }
}

fragment DualSearchMediaList_media on ExtendedMediaConnection {
  mediaList(first: $count, after: $cursor) {
    edges {
      node {
        id
        __typename
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    ...MediaList_media
  }
}

fragment DualSearchMediaList_offer on Event {
  ...MediaList_offer
}

fragment EventDualSearchPage_viewer on Viewer {
  account {
    profile {
      email
      id
    }
    id
  }
  event(id: $eventId, language: $language) {
    id
    sgId
    gps
    hostResultUrl
    products {
      type
      id
    }
    participant(startnumber: $startnumber, secondFactor: $secondFactor) {
      media {
        mediaInfo {
          count
        }
      }
      suggestionsByStartnumber(startnumber: $searchStartnumber) {
        mediaInfo {
          count
        }
        ...DualSearchMediaList_media
      }
      startnumber
      id
    }
    secondFactorType {
      type
      id
    }
    mainSearch
    searchDual
    smartSearch
    state
    marathonFoto
    ...EventOnlineView_onlineEvent
    ...DualSearchMediaList_offer
  }
}

fragment EventInfoCard_eventInfo on Event {
  id
  sgId
  beginsAt
  banner
  hostHomepageName
  hostHomepageUrl
  location
  name
  predecessorEvent {
    name
    id
  }
}

fragment EventOnlineView_onlineEvent on Event {
  id
  sgId
  hostResultUrl
  name
  participantUser
  mainSearch
  noMainSearchText
  ...EventInfoCard_eventInfo
  ...StartNumberSearch_info
  ...ExtendedSearch_event
}

fragment ExtendedSearchCategorySearchTab_categories on Event {
  mediaCollections {
    id
    name
  }
  searchAllPhotos
}

fragment ExtendedSearchDualSearchTab_event on Event {
  id
  sgId
  mainSearch
  ...StartNumberSearch_info
}

fragment ExtendedSearch_event on Event {
  id
  sgId
  mainSearch
  searchCollections
  ...ExtendedSearchCategorySearchTab_categories
  ...ExtendedSearchDualSearchTab_event
}

fragment MediaListItem_item on Media {
  id
  sgId
  name
  shotDate
  recheckStatus
  variants {
    name
    url
    id
  }
}

fragment MediaList_media on MediaConnection {
  edges {
    node {
      id
      sgId
      shotDate
      variants {
        name
        url
        id
      }
      recheckStatus
      recheckRequestedAt @include(if: $isRecheckPage)
      ...MediaListItem_item
    }
  }
}

fragment MediaList_offer on Event {
  products {
    id
    mediaCollection {
      name
      id
    }
    price
    type
  }
  voucherCampaigns {
    id
    banner
    name
    shortText
  }
}

fragment StartNumberSearch_info on Event {
  id
  gps
  mainSearch
  searchDual
  secondFactorEventSalt(individualPart: $individualPart)
  secondFactorType {
    type
    id
  }
  sgId
  hostResultUrl
  warnText
  faceWebcamOnly
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "eventId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "language",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "startnumber",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "searchStartnumber",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "secondFactor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "individualPart",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isRecheckPage",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sgId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = [
  (v4/*: any*/),
  (v1/*: any*/)
],
v6 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "mediaInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "count",
      "args": null,
      "storageKey": null
    }
  ]
},
v7 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "banner",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "EventDualSearchPageRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "EventDualSearchPage_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "EventDualSearchPageRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "account",
            "storageKey": null,
            "args": null,
            "concreteType": "Account",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "profile",
                "storageKey": null,
                "args": null,
                "concreteType": "Profile",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "email",
                    "args": null,
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ]
              },
              (v1/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "eventId"
              },
              {
                "kind": "Variable",
                "name": "language",
                "variableName": "language"
              }
            ],
            "concreteType": "Event",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "gps",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hostResultUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "products",
                "storageKey": null,
                "args": null,
                "concreteType": "Product",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v1/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "mediaCollection",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MediaCollection",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "price",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "participant",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "secondFactor",
                    "variableName": "secondFactor"
                  },
                  {
                    "kind": "Variable",
                    "name": "startnumber",
                    "variableName": "startnumber"
                  }
                ],
                "concreteType": "Participant",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "media",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ExtendedMediaConnection",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "suggestionsByStartnumber",
                    "storageKey": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "startnumber",
                        "variableName": "searchStartnumber"
                      }
                    ],
                    "concreteType": "ExtendedMediaConnection",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "mediaList",
                        "storageKey": null,
                        "args": (v7/*: any*/),
                        "concreteType": "MediaConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MediaEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Media",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "__typename",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v2/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "shotDate",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "variants",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MediaFile",
                                    "plural": true,
                                    "selections": [
                                      (v4/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "url",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v1/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "recheckStatus",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v4/*: any*/),
                                  {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "isRecheckPage",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "recheckRequestedAt",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "cursor",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hasNextPage",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "endCursor",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedHandle",
                        "alias": null,
                        "name": "mediaList",
                        "args": (v7/*: any*/),
                        "handle": "connection",
                        "key": "DualSearchMediaList_mediaList",
                        "filters": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "startnumber",
                    "args": null,
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "secondFactorType",
                "storageKey": null,
                "args": null,
                "concreteType": "SecondFactorType",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "mainSearch",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "searchDual",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "smartSearch",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "state",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "marathonFoto",
                "args": null,
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "participantUser",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "noMainSearchText",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "beginsAt",
                "args": null,
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hostHomepageName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hostHomepageUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "location",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "predecessorEvent",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": (v5/*: any*/)
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "secondFactorEventSalt",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "individualPart",
                    "variableName": "individualPart"
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "warnText",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "faceWebcamOnly",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "searchCollections",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "mediaCollections",
                "storageKey": null,
                "args": null,
                "concreteType": "MediaCollection",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v4/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "searchAllPhotos",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "voucherCampaigns",
                "storageKey": null,
                "args": null,
                "concreteType": "VoucherCampaign",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v8/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shortText",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          (v1/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "EventDualSearchPageRefetchQuery",
    "id": null,
    "text": "query EventDualSearchPageRefetchQuery(\n  $eventId: ID!\n  $language: String\n  $startnumber: ID!\n  $searchStartnumber: ID!\n  $count: Int!\n  $cursor: String\n  $secondFactor: String\n  $individualPart: String\n  $isRecheckPage: Boolean!\n) {\n  viewer {\n    ...EventDualSearchPage_viewer\n    id\n  }\n}\n\nfragment DualSearchMediaList_media on ExtendedMediaConnection {\n  mediaList(first: $count, after: $cursor) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    ...MediaList_media\n  }\n}\n\nfragment DualSearchMediaList_offer on Event {\n  ...MediaList_offer\n}\n\nfragment EventDualSearchPage_viewer on Viewer {\n  account {\n    profile {\n      email\n      id\n    }\n    id\n  }\n  event(id: $eventId, language: $language) {\n    id\n    sgId\n    gps\n    hostResultUrl\n    products {\n      type\n      id\n    }\n    participant(startnumber: $startnumber, secondFactor: $secondFactor) {\n      media {\n        mediaInfo {\n          count\n        }\n      }\n      suggestionsByStartnumber(startnumber: $searchStartnumber) {\n        mediaInfo {\n          count\n        }\n        ...DualSearchMediaList_media\n      }\n      startnumber\n      id\n    }\n    secondFactorType {\n      type\n      id\n    }\n    mainSearch\n    searchDual\n    smartSearch\n    state\n    marathonFoto\n    ...EventOnlineView_onlineEvent\n    ...DualSearchMediaList_offer\n  }\n}\n\nfragment EventInfoCard_eventInfo on Event {\n  id\n  sgId\n  beginsAt\n  banner\n  hostHomepageName\n  hostHomepageUrl\n  location\n  name\n  predecessorEvent {\n    name\n    id\n  }\n}\n\nfragment EventOnlineView_onlineEvent on Event {\n  id\n  sgId\n  hostResultUrl\n  name\n  participantUser\n  mainSearch\n  noMainSearchText\n  ...EventInfoCard_eventInfo\n  ...StartNumberSearch_info\n  ...ExtendedSearch_event\n}\n\nfragment ExtendedSearchCategorySearchTab_categories on Event {\n  mediaCollections {\n    id\n    name\n  }\n  searchAllPhotos\n}\n\nfragment ExtendedSearchDualSearchTab_event on Event {\n  id\n  sgId\n  mainSearch\n  ...StartNumberSearch_info\n}\n\nfragment ExtendedSearch_event on Event {\n  id\n  sgId\n  mainSearch\n  searchCollections\n  ...ExtendedSearchCategorySearchTab_categories\n  ...ExtendedSearchDualSearchTab_event\n}\n\nfragment MediaListItem_item on Media {\n  id\n  sgId\n  name\n  shotDate\n  recheckStatus\n  variants {\n    name\n    url\n    id\n  }\n}\n\nfragment MediaList_media on MediaConnection {\n  edges {\n    node {\n      id\n      sgId\n      shotDate\n      variants {\n        name\n        url\n        id\n      }\n      recheckStatus\n      recheckRequestedAt @include(if: $isRecheckPage)\n      ...MediaListItem_item\n    }\n  }\n}\n\nfragment MediaList_offer on Event {\n  products {\n    id\n    mediaCollection {\n      name\n      id\n    }\n    price\n    type\n  }\n  voucherCampaigns {\n    id\n    banner\n    name\n    shortText\n  }\n}\n\nfragment StartNumberSearch_info on Event {\n  id\n  gps\n  mainSearch\n  searchDual\n  secondFactorEventSalt(individualPart: $individualPart)\n  secondFactorType {\n    type\n    id\n  }\n  sgId\n  hostResultUrl\n  warnText\n  faceWebcamOnly\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '37390c8981f2249a51b1dd374639f7a5';

module.exports = node;
